var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", {value: true});
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {get: all[name], enumerable: true});
};

// src/index.ts
__markAsModule(exports);
__export(exports, {
  parseLut: () => parseLut
});

// src/formats/cube.ts
var defaultDomainMin = [0, 0, 0];
var defaultDomainMax = [1, 1, 1];
var parseTuple = (...rest) => {
  const rgbTuple = rest.map(Number);
  if (rgbTuple.length !== 3)
    throw new Error(`RGB tuple has ${rgbTuple.length}`);
  return rgbTuple;
};
var parseCubeLut = (data) => {
  const lines = new TextDecoder().decode(data).split("\n");
  const lut = {
    domain: {
      min: defaultDomainMin,
      max: defaultDomainMax
    },
    data: []
  };
  for (let i = 0; i < lines.length; i++) {
    try {
      const line = lines[i];
      if (line[0] === "#" || line === "")
        continue;
      const [identifier, ...rest] = line.split(" ");
      switch (identifier) {
        case "TITLE":
          lut.title = line.slice(7, -1);
          break;
        case "LUT_3D_SIZE":
          lut.type = identifier === "LUT_3D_SIZE" ? "3d" : "1d";
          if (!rest[0])
            throw new Error("Lut file does not specify size");
          lut.size = Number(rest[0]);
          break;
        case "DOMAIN_MIN":
          lut.domain.min = parseTuple(...rest);
          break;
        case "DOMAIN_MAX":
          lut.domain.max = parseTuple(...rest);
          break;
        default:
          lut.data.push(parseTuple(identifier, ...rest));
          break;
      }
    } catch (err) {
      throw new Error(`failed parsing cube lut at line ${i}: ${err}`);
    }
  }
  if (!lut.type)
    throw new Error("Lut file missing dimension");
  if (lut.data.length === 0)
    throw new Error("Lut has no data");
  return lut;
};

// src/lutFormat.ts
var parseLutFormat = ({data}) => {
  if (!data)
    throw new Error("`data` or `filePath` is required");
  if (data) {
  }
  return "cube";
};

// src/index.ts
var parseLut = async (input) => {
  const options = {
    data: new Uint8Array()
  };
  if (input.writeBigInt64BE) {
    options.data = new Uint8Array(input.buffer);
  }
  if (input.buffer) {
    options.data = input;
  }
  if (input.byteLength) {
    options.data = new Uint8Array(input);
  }
  const format = parseLutFormat(options);
  switch (format) {
    case "cube":
      return parseCubeLut(options.data);
  }
};
//# sourceMappingURL=index.js.map
